import { createSlice } from "@reduxjs/toolkit";
const initialState = { patient_detail: '', gender: '', usertype: '', chat_count: 0, update_prescription: '', checked_filters: [], active_tab:'this_month', patient_uuid:"", requested_by:"all",patient_id:"" };

const patientDetailReducer = createSlice({
  name: "patient_detail",
  initialState,
  reducers: {
    patientDetail(state, action) {
      state.patient_detail = action.payload;
    },  
    gender(state, action) {
      state.gender = action.payload;
    },
    usertype(state, action) {
      state.usertype = action.payload;
    },
    chatcount(state, action) {
      state.chat_count = action.payload;
    },
    updatePrescription(state,action){
      state.update_prescription=action.payload;
    },
    checkedFilters(state,action){
      state.checked_filters = action.payload;
    },
    activeTab(state,action){
      state.active_tab = action.payload;
    },
    setPatientUuid(state,action){
      state.patient_uuid(action.payload)
    },
    setDocBy(state,action){
      state.requested_by=action.payload;
    },
    setPatientID(state,action){
      state.patient_id=action.payload;
    }

   
  },
});
export const { patientDetail ,gender,usertype,chatcount,updatePrescription,checkedFilters,activeTab, setPatientUuid,setDocBy,setPatientID} = patientDetailReducer.actions;
export default patientDetailReducer.reducer;